/**
 * This file is auto-generated
 */

export enum Permission {
    // AgenticOrchestrator
    AgenticOrchestratorChatThreadsDelete = 'AgenticOrchestrator.ChatThreads.Delete',
    AgenticOrchestratorChatThreadsRead = 'AgenticOrchestrator.ChatThreads.Read',
    AgenticOrchestratorWorkflowDefinitionsCreate = 'AgenticOrchestrator.WorkflowDefinitions.Create',
    AgenticOrchestratorWorkflowDefinitionsDelete = 'AgenticOrchestrator.WorkflowDefinitions.Delete',
    AgenticOrchestratorWorkflowDefinitionsRead = 'AgenticOrchestrator.WorkflowDefinitions.Read',
    AgenticOrchestratorWorkflowDefinitionsUpdate = 'AgenticOrchestrator.WorkflowDefinitions.Update',
    AgenticOrchestratorWorkflowRunsRead = 'AgenticOrchestrator.WorkflowRuns.Read',
    AgenticOrchestratorWorkflowRunStepsRead = 'AgenticOrchestrator.WorkflowRunSteps.Read',
    AgenticOrchestratorWorkflowsExecute = 'AgenticOrchestrator.Workflows.Execute',

    // Auditing
    AuditingActionEventLogsRead = 'Auditing.ActionEventLogs.Read',
    AuditingCommandAuditLogsRead = 'Auditing.CommandAuditLogs.Read',

    // Auftragsbearbeitung
    AuftragsbearbeitungContainerActionsCreate = 'Auftragsbearbeitung.ContainerActions.Create',
    AuftragsbearbeitungContainerActionsDelete = 'Auftragsbearbeitung.ContainerActions.Delete',
    AuftragsbearbeitungContainerActionsRead = 'Auftragsbearbeitung.ContainerActions.Read',
    AuftragsbearbeitungContainerActionsUpdate = 'Auftragsbearbeitung.ContainerActions.Update',
    AuftragsbearbeitungContainerRentCreate = 'Auftragsbearbeitung.ContainerRent.Create',
    AuftragsbearbeitungContainerRentRead = 'Auftragsbearbeitung.ContainerRent.Read',
    AuftragsbearbeitungContainerStockCreate = 'Auftragsbearbeitung.ContainerStock.Create',
    AuftragsbearbeitungContainerStockRead = 'Auftragsbearbeitung.ContainerStock.Read',
    AuftragsbearbeitungContainerStockUpdate = 'Auftragsbearbeitung.ContainerStock.Update',
    AuftragsbearbeitungCountersCreate = 'Auftragsbearbeitung.Counters.Create',
    AuftragsbearbeitungCountersDelete = 'Auftragsbearbeitung.Counters.Delete',
    AuftragsbearbeitungCountersRead = 'Auftragsbearbeitung.Counters.Read',
    AuftragsbearbeitungCountersUpdate = 'Auftragsbearbeitung.Counters.Update',
    AuftragsbearbeitungOrderPositionsCreate = 'Auftragsbearbeitung.OrderPositions.Create',
    AuftragsbearbeitungOrderPositionsDelete = 'Auftragsbearbeitung.OrderPositions.Delete',
    AuftragsbearbeitungOrderPositionsRead = 'Auftragsbearbeitung.OrderPositions.Read',
    AuftragsbearbeitungOrderPositionsUpdate = 'Auftragsbearbeitung.OrderPositions.Update',
    AuftragsbearbeitungOrdersAttachmentsManage = 'Auftragsbearbeitung.Orders.Attachments.Manage',
    AuftragsbearbeitungOrdersAttachmentsRead = 'Auftragsbearbeitung.Orders.Attachments.Read',
    AuftragsbearbeitungOrdersCreate = 'Auftragsbearbeitung.Orders.Create',
    AuftragsbearbeitungOrdersDelete = 'Auftragsbearbeitung.Orders.Delete',
    AuftragsbearbeitungOrdersRead = 'Auftragsbearbeitung.Orders.Read',
    AuftragsbearbeitungOrdersUpdate = 'Auftragsbearbeitung.Orders.Update',
    AuftragsbearbeitungRequisitionContainerActionsCreate = 'Auftragsbearbeitung.RequisitionContainerActions.Create',
    AuftragsbearbeitungRequisitionContainerActionsRead = 'Auftragsbearbeitung.RequisitionContainerActions.Read',
    AuftragsbearbeitungRequisitionContainerActionsUpdate = 'Auftragsbearbeitung.RequisitionContainerActions.Update',
    AuftragsbearbeitungRequisitionPositionsCreate = 'Auftragsbearbeitung.RequisitionPositions.Create',
    AuftragsbearbeitungRequisitionPositionsRead = 'Auftragsbearbeitung.RequisitionPositions.Read',
    AuftragsbearbeitungRequisitionPositionsUpdate = 'Auftragsbearbeitung.RequisitionPositions.Update',
    AuftragsbearbeitungRequisitionsCreate = 'Auftragsbearbeitung.Requisitions.Create',
    AuftragsbearbeitungRequisitionsRead = 'Auftragsbearbeitung.Requisitions.Read',
    AuftragsbearbeitungRequisitionsUpdate = 'Auftragsbearbeitung.Requisitions.Update',
    AuftragsbearbeitungRulesetsCreate = 'Auftragsbearbeitung.Rulesets.Create',
    AuftragsbearbeitungRulesetsDelete = 'Auftragsbearbeitung.Rulesets.Delete',
    AuftragsbearbeitungRulesetsRead = 'Auftragsbearbeitung.Rulesets.Read',
    AuftragsbearbeitungRulesetsUpdate = 'Auftragsbearbeitung.Rulesets.Update',
    AuftragsbearbeitungSettingsRead = 'Auftragsbearbeitung.Settings.Read',
    AuftragsbearbeitungSettingsUpdate = 'Auftragsbearbeitung.Settings.Update',
    AuftragsbearbeitungStorageTransactionsCreate = 'Auftragsbearbeitung.StorageTransactions.Create',
    AuftragsbearbeitungStorageTransactionsRead = 'Auftragsbearbeitung.StorageTransactions.Read',
    AuftragsbearbeitungStorageTransactionsUpdate = 'Auftragsbearbeitung.StorageTransactions.Update',

    // Billing
    BillingCashJournalsCreate = 'Billing.CashJournals.Create',
    BillingCashJournalsDelete = 'Billing.CashJournals.Delete',
    BillingCashJournalsRead = 'Billing.CashJournals.Read',
    BillingCashJournalsUpdate = 'Billing.CashJournals.Update',
    BillingCountersCreate = 'Billing.Counters.Create',
    BillingCountersDelete = 'Billing.Counters.Delete',
    BillingCountersRead = 'Billing.Counters.Read',
    BillingCountersUpdate = 'Billing.Counters.Update',
    BillingInvoicesAttachmentsManage = 'Billing.Invoices.Attachments.Manage',
    BillingInvoicesAttachmentsRead = 'Billing.Invoices.Attachments.Read',
    BillingInvoicesCreate = 'Billing.Invoices.Create',
    BillingInvoicesDelete = 'Billing.Invoices.Delete',
    BillingInvoicesExport = 'Billing.Invoices.Export',
    BillingInvoicesRead = 'Billing.Invoices.Read',
    BillingInvoicesUpdate = 'Billing.Invoices.Update',
    BillingInvoiceSnapshotsAttachmentsRead = 'Billing.InvoiceSnapshots.Attachments.Read',
    BillingInvoiceSnapshotsExport = 'Billing.InvoiceSnapshots.Export',
    BillingInvoiceSnapshotsRead = 'Billing.InvoiceSnapshots.Read',
    BillingPriceListsCreate = 'Billing.PriceLists.Create',
    BillingPriceListsDelete = 'Billing.PriceLists.Delete',
    BillingPriceListsRead = 'Billing.PriceLists.Read',
    BillingPriceListsUpdate = 'Billing.PriceLists.Update',

    // Client
    PermissionsClientAcceptLegalDocuments = 'Permissions.Client.AcceptLegalDocuments',

    // Documents
    DocumentsCountersCreate = 'Documents.Counters.Create',
    DocumentsCountersDelete = 'Documents.Counters.Delete',
    DocumentsCountersRead = 'Documents.Counters.Read',
    DocumentsCountersUpdate = 'Documents.Counters.Update',
    DocumentsDocumentCreate = 'Documents.Document.Create',
    DocumentsDocumentRead = 'Documents.Document.Read',
    DocumentsDocumentUpdate = 'Documents.Document.Update',
    DocumentsDynamicExportDefinitionCreate = 'Documents.DynamicExportDefinition.Create',
    DocumentsDynamicExportDefinitionDelete = 'Documents.DynamicExportDefinition.Delete',
    DocumentsDynamicExportDefinitionRead = 'Documents.DynamicExportDefinition.Read',
    DocumentsDynamicExportDefinitionUpdate = 'Documents.DynamicExportDefinition.Update',
    DocumentsDynamicExportRunCreate = 'Documents.DynamicExportRun.Create',
    DocumentsDynamicExportRunDelete = 'Documents.DynamicExportRun.Delete',
    DocumentsDynamicExportRunRead = 'Documents.DynamicExportRun.Read',
    DocumentsFilesCreate = 'Documents.Files.Create',
    DocumentsFilesRead = 'Documents.Files.Read',
    DocumentsSettingsRead = 'Documents.Settings.Read',
    DocumentsSettingsUpdate = 'Documents.Settings.Update',
    DocumentsTemplateRead = 'Documents.Template.Read',

    // Mailing
    MailingEmailsCreate = 'Mailing.Emails.Create',
    MailingEmailsRead = 'Mailing.Emails.Read',
    MailingEmailStatusRead = 'Mailing.EmailStatus.Read',
    MailingMandantScopedSettingsRead = 'Mailing.MandantScopedSettings.Read',
    MailingMandantScopedSettingsUpdate = 'Mailing.MandantScopedSettings.Update',

    // Messages
    MessagesCashRegistersCreate = 'Messages.CashRegisters.Create',
    MessagesCashRegistersDelete = 'Messages.CashRegisters.Delete',
    MessagesCashRegistersRead = 'Messages.CashRegisters.Read',
    MessagesCashRegistersUpdate = 'Messages.CashRegisters.Update',
    MessagesScalesRegistrationCreate = 'Messages.ScalesRegistration.Create',
    MessagesScalesRegistrationDelete = 'Messages.ScalesRegistration.Delete',
    MessagesScalesRegistrationRead = 'Messages.ScalesRegistration.Read',
    MessagesScalesRegistrationUpdate = 'Messages.ScalesRegistration.Update',

    // Permissions
    PermissionsExternalApplicationsBlock = 'Permissions.ExternalApplications.Block',
    PermissionsExternalApplicationsCreate = 'Permissions.ExternalApplications.Create',
    PermissionsExternalApplicationsDelete = 'Permissions.ExternalApplications.Delete',
    PermissionsExternalApplicationsRead = 'Permissions.ExternalApplications.Read',
    PermissionsExternalApplicationsUnblock = 'Permissions.ExternalApplications.Unblock',
    PermissionsExternalApplicationsUpdate = 'Permissions.ExternalApplications.Update',
    PermissionsExternalErpConfigurationsCreate = 'Permissions.ExternalErpConfigurations.Create',
    PermissionsExternalErpConfigurationsDelete = 'Permissions.ExternalErpConfigurations.Delete',
    PermissionsExternalErpConfigurationsRead = 'Permissions.ExternalErpConfigurations.Read',
    PermissionsExternalErpConfigurationsUpdate = 'Permissions.ExternalErpConfigurations.Update',
    PermissionsGroupsCreate = 'Permissions.Groups.Create',
    PermissionsGroupsDelete = 'Permissions.Groups.Delete',
    PermissionsGroupsRead = 'Permissions.Groups.Read',
    PermissionsGroupsUpdate = 'Permissions.Groups.Update',
    PermissionsMandantenCreate = 'Permissions.Mandanten.Create',
    PermissionsMandantenDelete = 'Permissions.Mandanten.Delete',
    PermissionsMandantenRead = 'Permissions.Mandanten.Read',
    PermissionsMandantenUpdate = 'Permissions.Mandanten.Update',
    PermissionsPartnershipsCreate = 'Permissions.Partnerships.Create',
    PermissionsPartnershipsLock = 'Permissions.Partnerships.Lock',
    PermissionsPartnershipsRead = 'Permissions.Partnerships.Read',
    PermissionsPartnershipsUnlock = 'Permissions.Partnerships.Unlock',
    PermissionsUsersActivate = 'Permissions.Users.Activate',
    PermissionsUsersBlock = 'Permissions.Users.Block',
    PermissionsUsersCreate = 'Permissions.Users.Create',
    PermissionsUsersDelete = 'Permissions.Users.Delete',
    PermissionsUsersRead = 'Permissions.Users.Read',
    PermissionsUsersResetPassword = 'Permissions.Users.ResetPassword',
    PermissionsUsersUnblock = 'Permissions.Users.Unblock',
    PermissionsUsersUpdate = 'Permissions.Users.Update',

    // Scheduling
    SchedulingTriggersCreate = 'Scheduling.Triggers.Create',
    SchedulingTriggersDelete = 'Scheduling.Triggers.Delete',
    SchedulingTriggersRead = 'Scheduling.Triggers.Read',

    // Stammdaten
    StammdatenAddressesCreate = 'Stammdaten.Addresses.Create',
    StammdatenAddressesDelete = 'Stammdaten.Addresses.Delete',
    StammdatenAddressesRead = 'Stammdaten.Addresses.Read',
    StammdatenAddressesUpdate = 'Stammdaten.Addresses.Update',
    StammdatenConstructionSiteCreate = 'Stammdaten.ConstructionSite.Create',
    StammdatenConstructionSiteDelete = 'Stammdaten.ConstructionSite.Delete',
    StammdatenConstructionSiteRead = 'Stammdaten.ConstructionSite.Read',
    StammdatenConstructionSiteUpdate = 'Stammdaten.ConstructionSite.Update',
    StammdatenContactCreate = 'Stammdaten.Contact.Create',
    StammdatenContactDelete = 'Stammdaten.Contact.Delete',
    StammdatenContactRead = 'Stammdaten.Contact.Read',
    StammdatenContactUpdate = 'Stammdaten.Contact.Update',
    StammdatenContainerCreate = 'Stammdaten.Container.Create',
    StammdatenContainerDelete = 'Stammdaten.Container.Delete',
    StammdatenContainerRead = 'Stammdaten.Container.Read',
    StammdatenContainerUpdate = 'Stammdaten.Container.Update',
    StammdatenContainerTypeCreate = 'Stammdaten.ContainerType.Create',
    StammdatenContainerTypeDelete = 'Stammdaten.ContainerType.Delete',
    StammdatenContainerTypeRead = 'Stammdaten.ContainerType.Read',
    StammdatenContainerTypeUpdate = 'Stammdaten.ContainerType.Update',
    StammdatenCostBearerCreate = 'Stammdaten.CostBearer.Create',
    StammdatenCostBearerDelete = 'Stammdaten.CostBearer.Delete',
    StammdatenCostBearerRead = 'Stammdaten.CostBearer.Read',
    StammdatenCostBearerUpdate = 'Stammdaten.CostBearer.Update',
    StammdatenCostCenterCreate = 'Stammdaten.CostCenter.Create',
    StammdatenCostCenterDelete = 'Stammdaten.CostCenter.Delete',
    StammdatenCostCenterRead = 'Stammdaten.CostCenter.Read',
    StammdatenCostCenterUpdate = 'Stammdaten.CostCenter.Update',
    StammdatenCountersCreate = 'Stammdaten.Counters.Create',
    StammdatenCountersDelete = 'Stammdaten.Counters.Delete',
    StammdatenCountersRead = 'Stammdaten.Counters.Read',
    StammdatenCountersUpdate = 'Stammdaten.Counters.Update',
    StammdatenExternalErpImportFromErp = 'Stammdaten.ExternalErp.ImportFromErp',
    StammdatenLedgerAccountCreate = 'Stammdaten.LedgerAccount.Create',
    StammdatenLedgerAccountDelete = 'Stammdaten.LedgerAccount.Delete',
    StammdatenLedgerAccountRead = 'Stammdaten.LedgerAccount.Read',
    StammdatenLedgerAccountUpdate = 'Stammdaten.LedgerAccount.Update',
    StammdatenPaymentTermsCreate = 'Stammdaten.PaymentTerms.Create',
    StammdatenPaymentTermsDelete = 'Stammdaten.PaymentTerms.Delete',
    StammdatenPaymentTermsRead = 'Stammdaten.PaymentTerms.Read',
    StammdatenPaymentTermsUpdate = 'Stammdaten.PaymentTerms.Update',
    StammdatenRentVariantCreate = 'Stammdaten.RentVariant.Create',
    StammdatenRentVariantDelete = 'Stammdaten.RentVariant.Delete',
    StammdatenRentVariantRead = 'Stammdaten.RentVariant.Read',
    StammdatenRentVariantUpdate = 'Stammdaten.RentVariant.Update',
    StammdatenRulesetsCreate = 'Stammdaten.Rulesets.Create',
    StammdatenRulesetsDelete = 'Stammdaten.Rulesets.Delete',
    StammdatenRulesetsRead = 'Stammdaten.Rulesets.Read',
    StammdatenRulesetsUpdate = 'Stammdaten.Rulesets.Update',
    StammdatenServiceCreate = 'Stammdaten.Service.Create',
    StammdatenServiceDelete = 'Stammdaten.Service.Delete',
    StammdatenServiceRead = 'Stammdaten.Service.Read',
    StammdatenServiceUpdate = 'Stammdaten.Service.Update',
    StammdatenSettingsRead = 'Stammdaten.Settings.Read',
    StammdatenSettingsUpdate = 'Stammdaten.Settings.Update',
    StammdatenStorageLocationCreate = 'Stammdaten.StorageLocation.Create',
    StammdatenStorageLocationDelete = 'Stammdaten.StorageLocation.Delete',
    StammdatenStorageLocationRead = 'Stammdaten.StorageLocation.Read',
    StammdatenStorageLocationUpdate = 'Stammdaten.StorageLocation.Update',
    StammdatenVatCreate = 'Stammdaten.Vat.Create',
    StammdatenVatDelete = 'Stammdaten.Vat.Delete',
    StammdatenVatRead = 'Stammdaten.Vat.Read',
    StammdatenVatUpdate = 'Stammdaten.Vat.Update',
    StammdatenVehiclesCreate = 'Stammdaten.Vehicles.Create',
    StammdatenVehiclesDelete = 'Stammdaten.Vehicles.Delete',
    StammdatenVehiclesRead = 'Stammdaten.Vehicles.Read',
    StammdatenVehiclesUpdate = 'Stammdaten.Vehicles.Update',
    StammdatenVehicleTypeCreate = 'Stammdaten.VehicleType.Create',
    StammdatenVehicleTypeDelete = 'Stammdaten.VehicleType.Delete',
    StammdatenVehicleTypeRead = 'Stammdaten.VehicleType.Read',
    StammdatenVehicleTypeUpdate = 'Stammdaten.VehicleType.Update',

}

